import { render } from "./ModalAdd.vue?vue&type=template&id=ee147cae&scoped=true"
import script from "./ModalAdd.vue?vue&type=script&lang=js"
export * from "./ModalAdd.vue?vue&type=script&lang=js"

import "./ModalAdd.vue?vue&type=style&index=0&id=ee147cae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee147cae"]])

export default __exports__